"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFailure = exports.isSuccess = void 0;
function isSuccess(result) {
    return result.type === 'stop' || result.type === 'end of code' || result.type === 'return';
}
exports.isSuccess = isSuccess;
function isFailure(result) {
    return result.type === 'revert';
}
exports.isFailure = isFailure;
//# sourceMappingURL=interfaces.js.map